import { render, staticRenderFns } from "./u-tit-wrap-x-small.vue?vue&type=template&id=7466a0df&scoped=true&"
import script from "./u-tit-wrap-x-small.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-x-small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7466a0df",
  null
  
)

export default component.exports